var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title[_vm.$store.state.CN_EN]),expression:"$route.meta.title[$store.state.CN_EN]"}]},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }